import { FC } from 'react'

type Props = {
  title: string
  case: {
    type: string
    band: string
    price: string
  }
}

const Component: FC<Props> = ({ title, case: { type, band, price } }) => {
  return (
    <div>
      <h3 className="text-xl font-semibold text-secondary-700">{title}</h3>
      <p className="font-semibold my-4">
        {type}で月に<span className="text-primary-800">{band}</span>利用したい
      </p>
      <p>IoTBizではシンプルな3つの費用のみ</p>
      <div className="flex flex-wrap gap-6 my-4">
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 bg-primary-800 rounded-full" />
          <p>契約事務手数料</p>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 bg-primary-800 rounded-full" />
          <p>SIM発行手数料</p>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-2 h-2 bg-primary-800 rounded-full" />
          <p>月額プラン料金</p>
        </div>
      </div>

      <div className="flex flex-col items-center gap-6 p-[14px] md:p-10 text-xl">
        <div className="flex flex-col gap-2 md:flex-row w-full">
          <p className="w-full md:w-1/3 font-semibold text-gray-600">初期費用</p>
          <div className="flex w-full md:w-2/3">
            <p className="flex-1 text-gray-600">契約事務手数料</p>
            <p className="flex-1 text-right">3000円</p>
          </div>
        </div>

        <div className="flex flex-col gap-2 md:flex-row w-full">
          <p className="flex-1"></p>
          <div className="flex w-full md:w-2/3">
            <p className="flex-1 text-gray-600">SIM発行手数料</p>
            <p className="flex-1 text-right">394円/回線</p>
          </div>
        </div>

        <div className="w-full border-b border-1 border-divided" />

        <div className="flex flex-col gap-2 md:flex-row w-full">
          <p className="flex-1 w-full md:w-1/3 font-semibold text-gray-600">月額料金プラン</p>
          <div className="flex w-full md:w-2/3">
            <p className="flex-1 text-gray-600">{band}プラン</p>
            <p className="flex-1 text-right">{price}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Component
